import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, FileText, Link as LinkIcon, BarChart3, LogOut, Shield } from 'lucide-react';
import { toast } from 'sonner';

const NAV_ITEMS = [
  { path: '/skyportal/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/skyportal/users', label: 'Users', icon: Users },
  { path: '/skyportal/reports', label: 'Reports', icon: FileText },
  { path: '/skyportal/affiliates', label: 'Affiliates', icon: LinkIcon },
  { path: '/skyportal/analytics', label: 'Analytics', icon: BarChart3 },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('brandos_admin_token');
    toast.success('Logged out');
    navigate('/skyportal');
  };

  return (
    <div className="min-h-screen flex" style={{ background: '#0a0518' }} data-testid="admin-layout">
      <aside className="w-60 bg-white/[0.02] border-r border-white/5 flex flex-col">
        <div className="p-5 border-b border-white/5">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(145deg, #a855f7, #6d28d9)' }}>
              <Shield className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm" style={{ fontFamily: "'Manrope', sans-serif" }}>Sky Portal</p>
              <p className="text-purple-200/40 text-[10px] uppercase tracking-wider">Admin</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {NAV_ITEMS.map(item => {
            const Icon = item.icon;
            const active = location.pathname === item.path || (item.path !== '/skyportal/dashboard' && location.pathname.startsWith(item.path));
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition ${active ? 'bg-purple-500/20 text-white border border-purple-400/30' : 'text-purple-200/60 hover:bg-white/5 hover:text-white'}`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="p-3 border-t border-white/5">
          <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-red-300/70 hover:bg-red-500/10 hover:text-red-300 transition" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  );
}
